import { observer } from 'mobx-react-lite';
import { ApiaUtil, IconButton } from '@apia/components';
import { Form, Textarea as TTT, getVariant } from '@apia/theme';
import { ChangeEvent, useRef } from 'react';
import { getLabel } from '@apia/util';
import { getBase64FromFile } from '../util';
import { TMenuItem } from '@apia/components';
import { IAttachment } from '../types';

const TextArea = observer(
  ({
    isLoading,
    isRecording,
    disablePrevButton,
    disableNextButton,
    onSubmit,
    onChange,
    onClearHistory,
    onAttach,
    onRecord,
    onVideoRecord,
    onPrev,
    onNext,
    value,
  }: {
    isLoading: boolean;
    isRecording: boolean;
    disablePrevButton: boolean;
    disableNextButton: boolean;
    onClearHistory: () => unknown;
    onSubmit: () => unknown;
    onChange: (v: string) => unknown;
    onAttach: (ev: IAttachment) => unknown;
    onRecord: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onVideoRecord: () => unknown;
    onPrev: () => unknown;
    onNext: () => unknown;
    value: string;
    attachments: IAttachment[];
  }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const searchControlsRef = useRef<HTMLTextAreaElement>(null);
    const recordButton = (
      <IconButton
        className={`${isRecording ? 'isRecording' : ''}`}
        variant="icon-only"
        onClick={onRecord}
        disabled={isLoading && !isRecording}
        sx={{
          color: isRecording ? 'red' : undefined,
        }}
        icon={isRecording ? 'Stop' : 'Microphone'}
        id="transcribeAudio"
        iconSize="Sm"
        title={getLabel('lblAiRecordAudio').text}
      />
    );
    const handleAttachments = async (ev: ChangeEvent<HTMLInputElement>) => {
      if (ev.target.files) {
        for await (const f of ev.target.files) {
          const base64 = await getBase64FromFile(f);
          onAttach({
            value: base64,
            name: f.name,
            id: f.name,
          });
        }
        ev.target.value = '';
      }
    };
    const menuItemsList: TMenuItem[] = [
      {
        children: getLabel('btnUpload').text,
        title: getLabel('btnUpload').text,
        icon: 'File',
        onClick: () => fileInputRef.current?.click(),
        key: '2',
      },
      {
        title: getLabel('lblOpenCamera').text,
        children: getLabel('lblOpenCamera').text,
        icon: 'Camera',
        onClick: onVideoRecord,
        key: '3',
      },
      {
        title: getLabel('lblAiRecordAudio').text,
        children: getLabel('lblAiRecordAudio').text,
        key: '4',
        onClick: (event) =>
          onRecord(event as unknown as React.MouseEvent<HTMLButtonElement>),
        icon: isRecording ? 'Stop' : 'Microphone',
      },
      'separator',
      {
        icon: 'ArrowLeft',
        children: getLabel('btnAiPrevious').text,
        title: getLabel('btnAiPrevious').text,
        onClick: onPrev,
        disabled: disablePrevButton,
        key: '0',
      },
      {
        icon: 'ArrowRight',
        children: getLabel('btnAiNext').text,
        title: getLabel('btnAiNext').text,
        onClick: onNext,
        disabled: disableNextButton,
        key: '1',
      },
      'separator',
      {
        icon: 'Trash',
        onClick: onClearHistory,
        key: '5',
        children: getLabel('btnAiDeleteMessages').text,
        title: getLabel('btnAiDeleteMessages').text,
      },
    ];
    return (
      <Form
        onSubmit={(ev) => {
          ev.preventDefault();
          onSubmit();
        }}
        className="search_controls"
        {...getVariant('layout.common.newChat.form')}
      >
        <TTT
          ref={searchControlsRef}
          aria-label={
            /** TODO: Crear etiqueta para búsqueda */ 'Frase de búsqueda'
          }
          value={value}
          className="searchTextArea"
          onChange={(ev) => onChange(ev.target.value)}
          onKeyDown={(ev) => {
            if (ev.code === 'Enter' && !ev.shiftKey) {
              ev.preventDefault();
              (ev.target as HTMLElement)
                .closest('form')!
                .querySelector<HTMLElement>('[type="submit"]')!
                .click();
            }
          }}
        ></TTT>

        <input
          ref={fileInputRef}
          id="invisible__attach__file"
          type="file"
          multiple
          onChange={handleAttachments}
          sx={{ display: 'none' }}
        ></input>
        <IconButton
          className="ChatBarButton"
          disabled={isLoading}
          icon="Ellipsis"
          variant="icon-only"
          iconSize="Sm"
          onClick={(ev) => {
            ApiaUtil.instance.menu.open({
              menuProps: {
                anchorPoint: { x: ev.clientX, y: ev.clientY },
              },
              items: menuItemsList,
            });
          }}
        ></IconButton>
        {isRecording ? (
          recordButton
        ) : (
          <IconButton
            className="ChatBarButton"
            isLoading={isLoading}
            icon="ArrowRight"
            variant="icon-only"
            iconSize="Sm"
            title={getLabel('btnBus').title}
            type="submit"
          />
        )}
      </Form>
    );
  },
);
export default TextArea;
